import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { NonResidentLoginBody } from 'types/auth'

export const nonResidentApi = createApi({
  reducerPath: 'nonResidentApi',
  baseQuery,
  endpoints: (builder) => ({
    loginNonResident: builder.mutation<void, NonResidentLoginBody>({
      query: (body) => ({
        url: '/auth/login/non-resident',
        body,
        method: 'post',
      }),
    }),
  }),
})

export const { useLoginNonResidentMutation } = nonResidentApi
